import React, { useEffect, useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { change, getFormValues } from 'redux-form';
import { useAuth0 } from '@auth0/auth0-react';
import { axiosInstance } from '../../../api/axiosInstance';
import { auth0AuthroizationParams } from '../../../App';
import { jwtDecode } from 'jwt-decode';
import { setUser } from '@store/actions';
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useApplyWizardContext } from '../../../context/ApplyWizardContext';
import { useCountdown, useIsInIframe } from 'shared-components';
import { LoanSubmittingOverlay } from '@components/Apply/WizardShell';

const Auth0Callback = ({ allValues }) => {
  const history = useHistory();
  const { isAuthenticated, getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const { steps, setCurrentPath, changeStepAfterLogin, applicationFlow } = useApplyWizardContext();
  const dispatch = useDispatch();
  const location = useLocation();
  const { timeLeft } = useCountdown(5);
  const isOpenedInIframe = useIsInIframe();

  useLayoutEffect(() => {
    if (isOpenedInIframe) {
      window.parent.postMessage(JSON.stringify({ type: 'iframe-bg-remove' }), '*');
    }
  }, [isOpenedInIframe]);

  useEffect(() => {
    if (!isAuthenticated && timeLeft > 0) {
      console.log('NOT AUTHENTICATED, waiting...', timeLeft);
      return;
    }
    if (!isAuthenticated && timeLeft === 0) {
      console.log('NOT AUTHENTICATED');
      history.push('/');
      return;
    }
    (async () => {
      const { redirectTo } = location.state || {};
      console.log('EXECUTING CALLBACK');

      const token = await getAccessTokenSilently({ authorizationParams: auth0AuthroizationParams });
      const idToken = await getIdTokenClaims();
      const decodedToken = jwtDecode(token);
      console.log('decodedToken2', decodedToken);
      console.log('idToken2', idToken);
      console.log('token', token);
      const data = {
        user: {
          loggedIn: isAuthenticated,
          token,
          image: idToken?.picture,
          email: idToken.email,
          name: idToken?.nickname,
          id: decodedToken?.['https://tento.co/user_id'],
          expires: decodedToken && decodedToken.exp ? decodedToken.exp * 1000 : undefined,
        },
      };
      console.log('data', data);

      if (token) {
        axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        dispatch(setUser(data));
        dispatch(change('application', 'owner_1_email', idToken.email));
      }

      console.log('CALLBACK AUTH0');
      if (redirectTo) {
        console.log('redirectTo', redirectTo);

        if (steps.some((step) => step.path === redirectTo)) {
          setCurrentPath(redirectTo);
        } else {
          history.push(redirectTo);
        }
      } else {
        console.log('No redirectTo', allValues);
        console.log('applicationFlow', applicationFlow);

        if (applicationFlow === 'bcm') {
          if (allValues.business_id) {
            changeStepAfterLogin();
          } else if (
            allValues.business_name &&
            allValues.owner_1_email &&
            allValues.owner_1_mobile &&
            allValues.owner_1_first &&
            allValues.owner_1_last
          ) {
            // No account id but data present so it needs to be saved
            history.push(`/bcm2/app/create`);
          } else {
            // No account id and no deal data - fresh login (from homepage likely)
            history.push(`/bcm2/business/select`);
          }
        } else if (applicationFlow === 'bcm-short') {
          if (allValues.business_id) {
            changeStepAfterLogin();
          } else if (
            allValues.business_name &&
            allValues.owner_1_email &&
            allValues.owner_1_mobile &&
            allValues.owner_1_first &&
            allValues.owner_1_last
          ) {
            // No account id but data present so it needs to be saved
            history.push(`/bcm/app/create`);
          } else {
            // No account id and no deal data - fresh login (from homepage likely)
            history.push(`/bcm/business/select`);
          }
        } else {
          if (allValues.business_id) {
            changeStepAfterLogin();
          } else if (
            allValues.business_name &&
            allValues.owner_1_email &&
            allValues.owner_1_mobile &&
            allValues.owner_1_first &&
            allValues.owner_1_last &&
            allValues.loan_amount &&
            allValues.loan_terms &&
            allValues.loan_type
          ) {
            // No deal id but data present so it needs to be saved
            history.push(`/app/create`);
          } else {
            // No deal id and no deal data - fresh login (from homepage likely)
            history.push(`/app/select`);
          }
        }
      }
    })();
  }, [isAuthenticated, timeLeft]);
  // Was a bare <Spinner /> on a blank page — visually identical to a
  // hung load. Use the branded submitting overlay so the user sees
  // wizard chrome + a clear "signing you in" label, matching the rest
  // of the flow.
  return <LoanSubmittingOverlay label="SIGNING YOU IN" currentStepIndex={1} />;
};

const mapStateToProps = (state) => {
  return {
    allValues: getFormValues('application')(state) || {},
  };
};

export const Auth0CallbackContainer = connect(mapStateToProps)(Auth0Callback);

export default Auth0CallbackContainer;
